export interface RiskAssessmentPathOptions {
  /** Where the link was clicked from. Only the org-wide tasks table says. */
  from?: 'tasks';
  /** The distribution key, when the row the link was opened from was a rollup. */
  group?: string;
}

/** The one place the assessment's location is spelled out, so every caller navigates alike. */
export const getRiskAssessmentPath = (assessmentId: string, options: RiskAssessmentPathOptions = {}) => {
  const params = new URLSearchParams();

  if (options.group) params.set('group', options.group);
  if (options.from) params.set('from', options.from);

  const query = params.toString();

  return `/secure/fi/risk-assessments/${assessmentId}${query ? `?${query}` : ''}`;
};
